import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui/button';

interface PaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export function Pagination({ page, pageSize, total, onPageChange, className }: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : page * pageSize + 1;
  const to = Math.min((page + 1) * pageSize, total);

  return (
    <div className={cn('flex flex-wrap items-center justify-between gap-3 px-1 py-2', className)}>
      <p className="text-sm text-muted-foreground">
        {from}–{to} de {total}
      </p>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="icon-sm" disabled={page <= 0} onClick={() => onPageChange(0)} aria-label="Primeira">
          <ChevronsLeft className="size-4" />
        </Button>
        <Button variant="ghost" size="icon-sm" disabled={page <= 0} onClick={() => onPageChange(page - 1)} aria-label="Anterior">
          <ChevronLeft className="size-4" />
        </Button>
        <span className="min-w-[5rem] text-center text-sm tabular-nums">
          {page + 1} / {totalPages}
        </span>
        <Button variant="ghost" size="icon-sm" disabled={page >= totalPages - 1} onClick={() => onPageChange(page + 1)} aria-label="Próxima">
          <ChevronRight className="size-4" />
        </Button>
        <Button variant="ghost" size="icon-sm" disabled={page >= totalPages - 1} onClick={() => onPageChange(totalPages - 1)} aria-label="Última">
          <ChevronsRight className="size-4" />
        </Button>
      </div>
    </div>
  );
}
